import moment from 'moment';

import CompanyLogo from '~/components/CompanyLogo';
import { TableCell, TableRow } from '~/components/Table';
import { deepDig } from '~/lib/helpers';
import history from '~/lib/history';
import paths from '~/lib/paths';

import styles from './styles';

const columnComponents = {
  'company->name': ColumnName,
  last_visit_at: ColumnTimestamp,
};

const imageSize = 24;

function Company({ classes, columns, company, segmentId, style }) {
  return (
    <TableRow
      hover
      onClick={() => {
        const path = paths.company(company.id, segmentId);
        history.push(path);
      }}
      style={style}>
      {columns.map((column) => {
        const Column = columnComponents[column] || ColumnWithFallback;
        const title = deepDig(company.columns, column);

        return (
          <TableCell
            className={classes.root}
            ellipsis
            key={column}
            title={title}>
            <Column classes={classes} column={column} company={company} />
          </TableCell>
        );
      })}
    </TableRow>
  );
}

function ColumnName({ classes, column, company }) {
  const image = <CompanyLogo domain={company.domain} size={imageSize} />;

  return (
    <ColumnImage
      classes={classes}
      column={column}
      company={company}
      image={image}
    />
  );
}

function ColumnImage({ classes, column, company, image }) {
  return (
    <div className={classes.columnImage}>
      {image}

      <ColumnWithFallback
        as="div"
        className={classes.columnImageText}
        column={column}
        company={company}
      />
    </div>
  );
}

function ColumnTimestamp({ classes: _classes, column, company }) {
  const value = deepDig(company.columns, column);

  return <>{value ? moment(value).fromNow() : '—'}</>;
}

function ColumnWithFallback({
  as,
  classes: _classes,
  column,
  company,
  ...props
}) {
  const Component = as || React.Fragment;
  const value = deepDig(company.columns, column, '—');

  return <Component {...props}>{value}</Component>;
}

export default withStyles(styles)(Company);
